import React from 'react';

const GooglePlayBadge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="44"
    viewBox="0 0 142 48"
  >
    <defs>
      <linearGradient
        id="google-play-a"
        x1="61.024%"
        x2="26.115%"
        y1="4.84%"
        y2="71.968%"
      >
        <stop offset="0%" stopColor="#00A0FF" />
        <stop offset=".7%" stopColor="#00A1FF" />
        <stop offset="26%" stopColor="#00BEFF" />
        <stop offset="51.2%" stopColor="#00D2FF" />
        <stop offset="76%" stopColor="#00DFFF" />
        <stop offset="100%" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="google-play-b"
        x1="107.724%"
        x2="-130.67%"
        y1="49.424%"
        y2="49.424%"
      >
        <stop offset="0%" stopColor="#FFE000" />
        <stop offset="40.9%" stopColor="#FFBD00" />
        <stop offset="77.5%" stopColor="#FFA500" />
        <stop offset="100%" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="google-play-c"
        x1="86.389%"
        x2="-49.886%"
        y1="30.829%"
        y2="136.002%"
      >
        <stop offset="0%" stopColor="#FF3A44" />
        <stop offset="100%" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="google-play-d"
        x1="-18.581%"
        x2="42.275%"
        y1="-11.683%"
        y2="35.066%"
      >
        <stop offset="0%" stopColor="#32A071" />
        <stop offset="6.9%" stopColor="#2DA771" />
        <stop offset="47.6%" stopColor="#15CF74" />
        <stop offset="80.1%" stopColor="#06E775" />
        <stop offset="100%" stopColor="#00F076" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="142" height="48" fill="#08101D" rx="4" />
      <g fillRule="nonzero" transform="translate(13 11)">
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth=".2"
          d="M38,3.3 C38,4.1 37.8,4.8 37.3,5.3 C36.7,5.9 36,6.2 35.1,6.2 C34.2,6.2 33.5,5.9 32.9,5.3 C32.3,4.7 32,4 32,3.1 C32,2.2 32.3,1.5 32.9,0.9 C33.5,0.3 34.2,0 35.1,0 C35.5,0 35.9,0.1 36.3,0.3 C36.7,0.5 37,0.7 37.2,1 L36.7,1.5 C36.3,1 35.8,0.8 35.1,0.8 C34.5,0.8 33.9,1 33.5,1.5 C33,1.9 32.8,2.5 32.8,3.2 C32.8,3.9 33,4.5 33.5,4.9 C34,5.3 34.5,5.6 35.1,5.6 C35.8,5.6 36.3,5.4 36.8,4.9 C37.1,4.6 37.3,4.2 37.3,3.7 L35.1,3.7 L35.1,2.9 L38,2.9 L38,3.3 L38,3.3 Z M42.6,0.8 L39.9,0.8 L39.9,2.7 L42.4,2.7 L42.4,3.4 L39.9,3.4 L39.9,5.3 L42.6,5.3 L42.6,6.1 L39.1,6.1 L39.1,0.1 L42.6,0.1 L42.6,0.8 Z M45.9,6.1 L45.1,6.1 L45.1,0.8 L43.4,0.8 L43.4,0.1 L47.6,0.1 L47.6,0.8 L45.9,0.8 L45.9,6.1 Z M50.5,6.1 L50.5,0.1 L51.3,0.1 L51.3,6.1 L50.5,6.1 Z M54.7,6.1 L53.9,6.1 L53.9,0.8 L52.2,0.8 L52.2,0.1 L56.3,0.1 L56.3,0.8 L54.6,0.8 L54.6,6.1 L54.7,6.1 Z M64.2,5.3 C63.6,5.9 62.9,6.2 62,6.2 C61.1,6.2 60.4,5.9 59.8,5.3 C59.2,4.7 58.9,4 58.9,3.1 C58.9,2.2 59.2,1.5 59.8,0.9 C60.4,0.3 61.1,0 62,0 C62.9,0 63.6,0.3 64.2,0.9 C64.8,1.5 65.1,2.2 65.1,3.1 C65.1,4 64.8,4.7 64.2,5.3 Z M60.4,4.8 C60.8,5.2 61.4,5.5 62,5.5 C62.6,5.5 63.2,5.3 63.6,4.8 C64,4.4 64.3,3.8 64.3,3.1 C64.3,2.4 64.1,1.8 63.6,1.4 C63.2,1 62.6,0.7 62,0.7 C61.4,0.7 60.8,0.9 60.4,1.4 C60,1.8 59.7,2.4 59.7,3.1 C59.7,3.8 59.9,4.4 60.4,4.8 Z M66.2,6.1 L66.2,0.1 L67.1,0.1 L70,4.8 L70,0.1 L70.8,0.1 L70.8,6.1 L70,6.1 L66.9,1.2 L66.9,6.1 L66.2,6.1 L66.2,6.1 Z"
        />
        <path
          fill="#FFF"
          d="M59,14.7 C56.6,14.7 54.7,16.5 54.7,19 C54.7,21.4 56.6,23.3 59,23.3 C61.4,23.3 63.3,21.5 63.3,19 C63.3,16.4 61.4,14.7 59,14.7 Z M59,21.5 C57.7,21.5 56.6,20.4 56.6,18.9 C56.6,17.4 57.7,16.3 59,16.3 C60.3,16.3 61.4,17.3 61.4,18.9 C61.4,20.4 60.3,21.5 59,21.5 Z M49.7,14.7 C47.3,14.7 45.4,16.5 45.4,19 C45.4,21.4 47.3,23.3 49.7,23.3 C52.1,23.3 54,21.5 54,19 C54,16.4 52.1,14.7 49.7,14.7 Z M49.7,21.5 C48.4,21.5 47.3,20.4 47.3,18.9 C47.3,17.4 48.4,16.3 49.7,16.3 C51,16.3 52.1,17.3 52.1,18.9 C52.1,20.4 51,21.5 49.7,21.5 Z M38.6,16 L38.6,17.8 L42.9,17.8 C42.8,18.8 42.4,19.6 41.9,20.1 C41.3,20.7 40.3,21.4 38.6,21.4 C35.9,21.4 33.9,19.3 33.9,16.6 C33.9,13.9 36,11.8 38.6,11.8 C40,11.8 41.1,12.4 41.9,13.1 L43.2,11.8 C42.1,10.8 40.7,10 38.7,10 C35.1,10 32,13 32,16.6 C32,20.2 35.1,23.2 38.7,23.2 C40.7,23.2 42.1,22.6 43.3,21.3 C44.5,20.1 44.9,18.4 44.9,17.1 C44.9,16.7 44.9,16.3 44.8,16 L38.6,16 L38.6,16 Z M84,17.4 C83.6,16.4 82.6,14.7 80.4,14.7 C78.2,14.7 76.4,16.4 76.4,19 C76.4,21.4 78.2,23.3 80.6,23.3 C82.5,23.3 83.7,22.1 84.1,21.4 L82.7,20.4 C82.2,21.1 81.6,21.6 80.6,21.6 C79.6,21.6 79,21.2 78.5,20.3 L84.2,17.9 L84,17.4 L84,17.4 Z M78.2,18.8 C78.2,17.2 79.5,16.3 80.4,16.3 C81.1,16.3 81.8,16.7 82,17.2 L78.2,18.8 Z M73.5,22.9 L75.4,22.9 L75.4,10.4 L73.5,10.4 L73.5,22.9 Z M70.5,15.6 C70,15.1 69.2,14.6 68.2,14.6 C66.1,14.6 64.1,16.5 64.1,18.9 C64.1,21.3 66,23.1 68.2,23.1 C69.2,23.1 70,22.6 70.4,22.1 L70.5,22.1 L70.5,22.7 C70.5,24.3 69.6,25.2 68.2,25.2 C67.1,25.2 66.3,24.4 66.1,23.7 L64.5,24.4 C65,25.5 66.2,26.9 68.3,26.9 C70.5,26.9 72.3,25.6 72.3,22.5 L72.3,14.9 L70.5,14.9 L70.5,15.6 L70.5,15.6 Z M68.3,21.5 C67,21.5 65.9,20.4 65.9,18.9 C65.9,17.4 67,16.3 68.3,16.3 C69.6,16.3 70.6,17.4 70.6,18.9 C70.6,20.4 69.6,21.5 68.3,21.5 Z M92.7,10.4 L88.2,10.4 L88.2,22.9 L90.1,22.9 L90.1,18.2 L92.7,18.2 C94.8,18.2 96.8,16.7 96.8,14.3 C96.8,11.9 94.8,10.4 92.7,10.4 L92.7,10.4 Z M92.8,16.4 L90.1,16.4 L90.1,12.1 L92.8,12.1 C94.2,12.1 95,13.3 95,14.2 C94.9,15.3 94.1,16.4 92.8,16.4 Z M104.3,14.6 C102.9,14.6 101.5,15.2 101,16.5 L102.7,17.2 C103.1,16.5 103.7,16.3 104.4,16.3 C105.4,16.3 106.3,16.9 106.4,17.9 L106.4,18 C106.1,17.8 105.3,17.5 104.5,17.5 C102.7,17.5 100.9,18.5 100.9,20.3 C100.9,22 102.4,23.1 104,23.1 C105.3,23.1 105.9,22.5 106.4,21.9 L106.5,21.9 L106.5,22.9 L108.3,22.9 L108.3,18.1 C108.1,15.9 106.4,14.6 104.3,14.6 L104.3,14.6 Z M104.1,21.5 C103.5,21.5 102.6,21.2 102.6,20.4 C102.6,19.4 103.7,19.1 104.6,19.1 C105.4,19.1 105.8,19.3 106.3,19.5 C106.1,20.7 105.1,21.5 104.1,21.5 L104.1,21.5 Z M114.6,14.9 L112.5,20.3 L112.4,20.3 L110.2,14.9 L108.2,14.9 L111.5,22.5 L109.6,26.7 L111.5,26.7 L116.6,14.9 L114.6,14.9 L114.6,14.9 Z M97.8,22.9 L99.7,22.9 L99.7,10.4 L97.8,10.4 L97.8,22.9 Z"
        />
        <path
          fill="url(#google-play-a)"
          d="M0.4,0.5 C0.1,0.8 0,1.3 0,1.9 L0,24 C0,24.6 0.2,25.1 0.5,25.4 L0.6,25.5 L13,13.1 L13,12.9 L0.4,0.5 Z"
        />
        <path
          fill="url(#google-play-b)"
          d="M17,17.3 L12.9,13.2 L12.9,12.9 L17,8.8 L17.1,8.9 L22,11.7 C23.4,12.5 23.4,13.8 22,14.6 L17,17.3 L17,17.3 Z"
        />
        <path
          fill="url(#google-play-c)"
          d="M17.1,17.2 L12.9,13 L0.4,25.5 C0.9,26 1.6,26 2.5,25.6 L17.1,17.2"
        />
        <path
          fill="url(#google-play-d)"
          d="M17.1,8.8 L2.5,0.5 C1.6,8.32667268e-17 0.9,0.1 0.4,0.6 L12.9,13 L17.1,8.8 L17.1,8.8 Z"
        />
        <path
          fill="#000"
          d="M17,17.1 L2.5,25.3 C1.7,25.8 1,25.7 0.5,25.3 L0.4,25.4 L0.5,25.5 C1,25.9 1.7,26 2.5,25.5 L17,17.1 Z"
          opacity=".2"
        />
        <path
          fill="#000"
          d="M0.4,25.3 C0.1,25 0,24.5 0,23.9 L0,24 C0,24.6 0.2,25.1 0.5,25.4 L0.5,25.3 L0.4,25.3 Z M22,14.3 L17,17.1 L17.1,17.2 L22,14.4 C22.7,14 23,13.5 23,13 C23,13.5 22.6,13.9 22,14.3 L22,14.3 Z"
          opacity=".12"
        />
        <path
          fill="#FFF"
          d="M2.5,0.6 L22,11.7 C22.6,12.1 23,12.5 23,13 C23,12.5 22.7,12 22,11.6 L2.5,0.5 C1.1,-0.3 0,0.3 0,1.9 L0,2 C0,0.5 1.1,-0.2 2.5,0.6 Z"
          opacity=".25"
        />
      </g>
    </g>
  </svg>
);

export default GooglePlayBadge;
